import { Palette } from '@mui/material/styles';
import { FontSize } from '@store/types/UserStoreSlice.type';
import colors from '@theme/colors';
import { getTypographyVariants } from '@theme/styleOverrides/typography';

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    filledBorder: true;
  }
}

export const MuiChip = ({ palette, fontSize }: { palette: Palette; fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      '& .MuiChip-label': {
        ...getTypographyVariants(fontSize).root,
        display: 'flex',
      },
    },
  },
  variants: [
    {
      props: {},
      style: {
        paddingLeft: '4px',
        paddingRight: '4px',
      },
    },
    {
      props: { variant: 'outlined' },
      style: {
        color: palette.theme === 'lio' ? colors.FADED_NAVY : palette.text.main,
        backgroundColor: palette.theme === 'lio' ? palette.common.white : palette.background.paper,
        borderColor: 'rgb(189, 189, 189)', // TODO: find in theme
      },
    },
    {
      props: { variant: 'filled' },
      style: {
        color: colors.WHITE_100,
        backgroundColor: palette.theme === 'lio' ? colors.FADED_NAVY : palette.background.main,
        '&:hover': {
          backgroundColor: palette.theme === 'lio' ? colors.FADED_NAVY : colors.BLACK_30,
        },

        '&:focus-visible': {
          backgroundColor: 'rgb(189, 189, 189)',
        },
      },
    },
    {
      props: { variant: 'filledBorder' },
      style: {
        color: palette.theme === 'lio' ? palette.common.white : palette.background.main,
        backgroundColor: palette.theme === 'lio' ? colors.FADED_NAVY : palette.background.main,
        border: `thin solid #bdbdbd`, // TODO: is there a color we can use? this doenst exist but maybe one close does
      },
    },
    // secondary styles for the darker blue/coral chips found on home page
    {
      props: { color: 'secondary', variant: 'filled' },
      style: {
        color: colors.WHITE_100,
        backgroundColor: colors.CORAL,
        borderColor: colors.CORAL,
        '&:hover': {
          backgroundColor: colors.CORAL,
        },

        '&:focus-visible': {
          backgroundColor: colors.CORAL,
          outline: '-webkit-focus-ring-color auto 1px',
        },
      },
    },
    {
      props: { color: 'secondary', variant: 'outlined' },
      style: {
        color: colors.WHITE_100,
        backgroundColor: '#465077', // TODO could this be in theme/is there a similar color to use

        border: 'none',
        '&:hover': {
          backgroundColor: '#465077 !important', // something in muibutton is overriding this specific style
        },

        '&:focus-visible': {
          backgroundColor: '#465077',
          outline: '-webkit-focus-ring-color auto 1px',
        },
      },
    },
  ],
});
